import classNames from 'classnames';
import { Card } from 'react-bootstrap';
import { useAppContext } from '@/Main';
import { changeBgColor } from '@/utils/pre-load/changeBgColor';
import FalconCardHeader from '@/components/common/FalconCardHeader';
import HelpTooltip from '@/app/common/components/HelpTooltip';

type CardBarChartLoadingProps = {
  title: string;
  tooltip?: string;
  limit: number;
  width: number;
  height: number;
  margin: number;
  marginBetweenLine: number;
  showFooter?: boolean;
  className?: string;
  fillHeight?: boolean;
};

const LOADING_BAR_HEIGHTS = [
  100, 120, 79, 32, 72, 10, 90, 50, 20, 38, 67, 20, 80, 11, 90, 35, 70, 15,
  34, 92, 14, 93, 49, 83, 37, 10, 90, 52, 72, 13, 70, 50, 20, 90, 95, 110
];

const CardBarChartLoading = ({
  title,
  tooltip,
  limit,
  width,
  height,
  margin,
  marginBetweenLine,
  showFooter = true,
  className,
  fillHeight = false
}: CardBarChartLoadingProps) => {
  const {
    config: { theme }
  } = useAppContext() as { config: { theme: string } };

  return (
    <Card
      className={classNames(className, fillHeight && 'h-100 d-flex flex-column')}
    >
      <FalconCardHeader
        title={
          <div>
            {title}
            {tooltip ? <HelpTooltip html={tooltip} /> : null}
          </div>
        }
        titleTag="h6"
        className="py-2"
        light
      />
      <Card.Body
        className={classNames(
          'px-0',
          fillHeight &&
            'flex-grow-1 d-flex align-items-center justify-content-center overflow-hidden'
        )}
      >
        <div
          style={{
            textAlign: 'center',
            margin: fillHeight ? 0 : `${margin}px 0px`
          }}
        >
          {LOADING_BAR_HEIGHTS.slice(0, limit).map((item, index) => (
            <div
              key={index}
              className="vertical_line_loading"
              style={{ height: `${item + height}px` }}
            />
          ))}
        </div>
      </Card.Body>
      {showFooter && (
        <Card.Footer className="bg-body-tertiary fs--2">
          <div className="text_chart_loading" />
        </Card.Footer>
      )}

      <style>
        {`
          .text_chart_loading,.vertical_line_loading{
              background:${changeBgColor(theme)};
              background-size: 200% 100%;
              background-position: 100% 0;
          }
          .vertical_line_loading{
              width :${width}px;
              margin: 0px ${marginBetweenLine}px;
           }
       `}
      </style>
    </Card>
  );
};

export default CardBarChartLoading;
